/*
 * @Description: 房源维护列表
 * @Author: 段生华
 * @Date: 2019-05-07 17:20:24
 * @LastEditTime: 2019-07-04 11:51:33
 * @LastEditors: Please set LastEditors
 */

import React from 'react';
import {Button, message, Modal, Spin, Upload} from 'antd';
import Cookies from 'js-cookie';
import PageWrap from '../../components/PageWrap';
import SuperForm from '../../components/SuperForm';
import TableDOM from '../../components/Table';
import AuthButton from '../../components/AuthButton/AuthButton';
import {postFrom, config, transterQuery, post, uploadNewEnclosure} from '../../axios';
import {formatTime, handleExportParams} from '../../utils';
import JrApiLog from "../Other/JrApiLog";

import {
    API_house_findHouseBillCount,
    API_report_findHouseBillExprot,
    API_roomType_batchGeneration,
} from "../../axios/config";
import DeviceDetail from "./deviceDetail";
import DeviceNewDetail from "./deviceNewDetail";
import {Link} from "react-router-dom";
import {deviceBillStatusIsMap} from "../../axios/dictionaries";
import axios from "axios";

export default class Page extends React.Component {


    constructor() {
        super();
        this.state = {
            loading: false, //页面加载中
            params: { //搜索参数
                keyword: '',
                syncStatus:'',
                status: '',
                mustPayDate: '',
                pageSize: 10,
            },
            showBillImportModal:false,  //批量导入账单弹窗
            billImporLoad:false,       //批量导入账单Loading
            billImportData:'',      //批量导入账单 数据显示
            tableTotalMny: 0, //表格总金额
            receivedMoney: 0,
            vacantMoney: 0, //空置金额
            current: 1, //当前页
            tableData: [], //表格数据
            tableLoading: false, //表格加载中
            tableTotal: 0, //表格总数据量
            showAddModal: false, //新增组件弹窗
        }

        let loginData = Cookies.get('loginData');
        if (loginData) { //校验登录是否失效
            loginData = JSON.parse(loginData);
            if (loginData.merchantId) {  //为商户人员添加商户id
                this.merchantId = loginData.merchantId || 0;
            }
        }
    }




    componentDidMount() {
        this.handleSearch();
    }

    handleSearch = (values = {}) => { //表单搜索/分页
        let { params, current } = this.state;
        let data = {};

        if (values.current) {
            data = Object.assign({}, params, values);
        } else {
            data = Object.assign({}, params, values, { current });
        }
        this.setState({ params: Object.assign({}, params, values), tableLoading: true });

        // postFrom({ url: config.API_house_findHouseBillPageList, data }).then(res => {
        //     this.setState({ current: res.current, tableTotal: res.total, tableData: res.records, tableLoading: false });
        // }).catch(err => {
        //     message.error(err.message || '获取列表失败');
        //     this.setState({ tableLoading: false });
        // });
        axios.all([
            postFrom({ url: config.API_house_findHouseBillPageList, data }),
            postFrom({ url: config.API_house_findHouseBillCount, data }),
        ]).then(axios.spread((listRes, countRes) => {
            this.setState({ tableTotalMny: countRes!=null?(countRes.billMoney!=undefined?countRes.billMoney:0):0,
                receivedMoney:countRes!=null ?( countRes.receivedMoney!=undefined?countRes.receivedMoney:0):0, tableTotal: listRes.total,
                vacantMoney: countRes!=null?(countRes.endAmount!=undefined?countRes.endAmount:0):0,
                current: listRes.current, tableData: listRes.records, tableLoading: false });
        })).catch(err => {
            message.error(err.message || '获取列表失败');
            this.setState({ tableLoading: false });
        })

    }

    handleJrApiLogInfo(tableName,id) {
        this.jrApiLogRef.open(tableName,id);
    }


    // importBillProps = {
    //     //批量账单导入
    //     action: config.API_bill_importBill,
    //     accept: '.xls',
    //     data:{ "mustPayDate": ''},
    //     showUploadList: false,
    //     beforeUpload: (file) => {
    //         this.handleSearch()
    //         let { params, current } = this.state;
    //         console.log(params.mustPayDate)
    //         debugger
    //         if(params.mustPayDate===''||params.mustPayDate===null){
    //             message.error('请选择周期月份!');
    //             return false;
    //         }
    //
    //         message.loading(`${file.name}上传中...`);
    //     },
    //     onChange: (info) => {
    //
    //         if (info.file.status === 'done') {
    //             let res = info.file.response;
    //             if (res.code === 0) {
    //                 message.success(`${info.file.name}文件导入成功`);
    //                 if(res.data){
    //                     this.setState({showBillImportModal:true})
    //                     this.handleGetBillImportLog(res.data)
    //                 }
    //             } else {
    //                 if(Array.isArray(res.data)){
    //                     Modal.error({
    //                         className:'importModal',
    //                         title: res.message || `${info.file.name}文件导入失败`,
    //                         content: <div style={{whiteSpace:'pre',maxHeight:'80vh',overflow:'auto'}}>{res.data.join('\n')}</div> ,
    //                     });
    //                 }else{
    //                     message.error(res.message || `${info.file.name}文件导入失败`);
    //                 }
    //             }
    //         } else if (info.file.status === 'error') {
    //             message.error(`${info.file.name}文件上传失败`);
    //         }
    //     },
    // };

    handleGetBillImportLog = (id) => {  //获取批量导入账单的异步进程日志
        this.setState({billImporLoad:true})
        this.billTimer = setInterval(()=>{
            postFrom({ url: config.API_device_getImportLog, data: { threadNo: id, } }).then(res => {
                if (res) {
                    this.setState({billImporLoad:false,billImportData:res.replace(/\\r\\n/g,'\n')})
                } else {
                    message.error(res.message ||  '操作失败!');
                    clearInterval(this.billTimer)
                }
            }).catch(err => {
                message.error(err.message || '操作异常!');
                clearInterval(this.billTimer)
            });
        },2000)
    }

    closeBillImport = ()=>{  //清除 批量账单导入定时器
        clearInterval(this.billTimer)
        this.handleSearch()
        this.setState({showBillImportModal:false})
    }


    handleInfo = (id) => {
        this.DeviceDetailRef.open(id).then(res => {
            this.handleSearch()
        })
    }

    handleNewInfo = (id) => {
        this.DeviceNewDetailRef.open(id).then(res => {
            this.handleSearch()
        })
    }

    postAsyncBatchCheck(id) {
        return post({ url: API_roomType_batchGeneration  +'?id=' + id }).then(() => {
            message.success('批量生成中，请10到20分钟后查看')
        }).catch(e => {
            message.error(e.message)
        })
    }



    handleAsyncBatchCheck() {
        this.postAsyncBatchCheck().then(() =>{
            this.handleSearch()
        })
    }

    uploadContract = (name, res) => { //上传合同照片
        this.setState({showBillImportModal:true})
        this.handleGetBillImportLog(res)
    }

    renderUploadWrap (action,success,data = {}) {
        const uploadConfig = uploadNewEnclosure({
            //批量账单导入
            action: action,
            accept: '.xls',
            tableName: 'rent_contract', success: this.uploadContract, attachType: 5
            // data:{ "mustPayDate": this.state.params.mustPayDate},
           // showUploadList: false,
            // beforeUpload: (file) => {
            //     // message.loading(`${file.name}上传中...`);
            // },
            // onChange: (info) => {
            //     if (info.file.status === 'done') {
            //         let res = info.file.response;
            //         if (res.code === 0) {
            //             message.success(`${info.file.name}文件导入成功`);
            //             if(res.data){
            //                 this.setState({showBillImportModal:true})
            //                 this.handleGetBillImportLog(res.data)
            //             }
            //         } else {
            //             if(Array.isArray(res.data)){
            //                 Modal.error({
            //                     className:'importModal',
            //                     title: res.message || `${info.file.name}文件导入失败`,
            //                     content: <div style={{whiteSpace:'pre',maxHeight:'80vh',overflow:'auto'}}>{res.data.join('\n')}</div> ,
            //                 });
            //             }else{
            //                 message.error(res.message || `${info.file.name}文件导入失败`);
            //             }
            //         }
            //     } else if (info.file.status === 'error') {
            //         message.error(`${info.file.name}文件上传失败`);
            //     }
            // },
        })
        return (
            <Upload {...uploadConfig}>
                <Button type="primary" icon="import">导入设备账单</Button>
            </Upload>
        )
    }

    render() {
        let {
            loading,
            current,
            tableData,
            tableLoading,
            tableTotal,
            tableTotalMny,
            receivedMoney,
            vacantMoney,
            showAddModal,
        } = this.state;
        return (
            <PageWrap
                loading={loading}
            >
                <div className="search-wrapper">
                    <SuperForm
                        data={searchData()}
                        sumbit={this.handleSearch}
                        addParams={'current'}
                    />
                    <div className="search-btn-list">
                        {/*<AuthButton  authkey="z-4-2" type="primary" icon="export" onClick={() => this.handleNewInfo(null) }>账单核销</AuthButton>*/}
                        <AuthButton authkey="z-4-2" type="primary" icon="export">
                            <Button type="primary" ><Link to="/admin/operate/operateMaintain">账单模板下载</Link></Button>
                        </AuthButton>
                        <AuthButton authkey="z-4-3" type="primary" icon="import">
                            {this.renderUploadWrap(`${config.API_device_importBill}?${transterQuery(Object.assign({}, handleExportParams() || {}, this.state.params, { current }))}`)}
                        </AuthButton>
                        <AuthButton authkey="z-4-5" type="primary" icon="export" href={`${config.API_report_findHouseBillExprot}?${transterQuery(Object.assign({}, handleExportParams() || {}, this.state.params, { current }))}`}>
                            导出设备账单
                        </AuthButton>
                    </div>
                </div>
                <TableDOM
                    columns={columns({ current, handleEdit: this.handleEdit, handleInfo: this.handleInfo,handleNewInfo: this.handleNewInfo,handleJrApiLogInfo:this.handleJrApiLogInfo.bind(this) })}
                    data={tableData}
                    loading={tableLoading}
                    total={tableTotal}
                    totalMny={tableTotalMny}
                    vacantBillMoney={vacantMoney}
                    receivedMoney={receivedMoney}
                    current={current}
                    onChange={this.handleSearch}
                    scroll={{x: 1500}}
                />
                {/* 批量账单导入 */}
                <Modal
                    destroyOnClose
                    maskClosable={false}
                    visible={this.state.showBillImportModal}
                    onCancel={this.closeBillImport}
                    footer={<Button onClick={this.closeBillImport} type="primary">确定</Button>}
                >
                    <Spin spinning={this.state.billImporLoad}>
                        <div style={{maxHeight:'80vh',overflow:'auto',padding:'30px',whiteSpace:'pre'}}>
                            {this.state.billImportData}
                        </div>
                    </Spin>
                </Modal>
                <JrApiLog ref={ref=>{
                    this.jrApiLogRef=ref;
                }}/>
                <DeviceDetail wrappedComponentRef={ ref=> this.DeviceDetailRef = ref } />
                <DeviceNewDetail wrappedComponentRef={ ref=> this.DeviceNewDetailRef  = ref } />
            </PageWrap>
        )
    }


}

const searchData = () => {
    let data =  [
        {
            tagName: 'Input',
            formConfig: { name: 'buildingNo' },
            attribute: { placeholder: '请输入小区/楼栋', style: { width: '130px' } },
        },
        {
            tagName: 'Input',
            formConfig: { name: 'projectKeyword' },
            attribute: { placeholder: '请输入项目名称', style: { width: '200px' } },
        },
        {
            tagName: 'Input',
            formConfig: { name: 'floor' },
            attribute: { placeholder: '请输入楼层', style: { width: '130px' } },
        },
        {
            tagName: 'Input',
            formConfig: { name: 'roomNo' },
            attribute: { placeholder: '请输入房号', style: { width: '130px' } },
        },
        {
            tagName: 'Select',
            formConfig: { name: 'billStatus' },
            attribute: { placeholder: '请选择账单状态', style: { width: '140px' } },
            optionData: [{ title: '全部', value: '' }].concat(deviceBillStatusIsMap), //.concat(dicHouseStatus)
            notResult: '',
        },
        {
            tagName: 'MonthPicker',
            formConfig: { name: 'mustPayDate' },
            attribute: { placeholder: '请选择周期月份',type:'month',format:"YYYY-MM", style: { width: "172.7px" } },
        }
    ]

    return data;
};

const columns = ({ handleEdit, handleInfo,handleJrApiLogInfo }) => [
    {
        title: '房源编号',
        dataIndex: 'houseNo',
        fixed: 'left'
    },
    {
        title: '小区/楼栋',
        dataIndex: 'buildingName'
    },
    {
        title: '项目名称',
        dataIndex: 'projectName'
    },
    {
        title: '房号',
        dataIndex: 'roomNo'
    },
    {
        title: '户型',
        dataIndex: 'layout'
    },
    {
        title: '验收日期',
        dataIndex: 'acceptanceDate'
        ,render: text => formatTime(text, 'YYYY-MM-DD')
    },
    {
        title: '应收日期',
        dataIndex: 'mustPayDate'
        ,render: text => formatTime(text, 'YYYY-MM-DD')
    },
    {
        title: '账单周期',
        dataIndex: 'cycleDate'
        ,render: text => formatTime(text, 'YYYY-MM')
    },
    {
        title: '账单开始日期',
        dataIndex: 'billBeginDate'
        ,render: text => formatTime(text, 'YYYY-MM-DD')
    },
    {
        title: '账单结束日期',
        dataIndex: 'billEndDate'
        ,render: text => formatTime(text, 'YYYY-MM-DD')
    },
    {
        title: '应收金额',
        dataIndex: 'rent'
    },
    {
        title: '实收金额',
        dataIndex: 'rent',
        render(text, record, index) {
            return record.status===1 ? record.rent : 0
        }
    },
    {
        title: '真实金额',
        dataIndex: 'monthSsPrice',
        render(text, record, index) {
            return record.monthSsPrice ? record.monthSsPrice : 0
        }
    },
    {
        title: '空置账单金额',
        dataIndex: 'rent',
        render(text, record, index) {
            return record.status===1 ?  '-' : record.rent
        }
    },
    {
        title: '账单状态',
        dataIndex: 'status'
        ,render: text => text===1?'已租':'空置'
    },
    {
        title: '账单备注',
        dataIndex: 'billRemarks'
    },
    {
        title: '核销状态',
        dataIndex: 'writeOff'
        ,render: text => text===1?'已核销':'未核销'
    },
    {
        title: '核销时间',
        dataIndex: 'writeOffTime',
        render(text) {
            if (!text) return '-'
            return formatTime(text)
        }
    },
    {
        title: '账单创建时间',
        dataIndex: 'createTime',
        render(text) {
            if (!text) return '-'
            return formatTime(text)
        }
    },
    {
        title: '操作',
        dataIndex: 'action',
        width: 200,
        fixed: 'right',
        render(text, record, index) {
            const rentLink = {
                pathname: '/admin/rentContract/list',
                state: { houseId: record.id }
            }
            return <span>
              <AuthButton authkey="z-4-4">
                    <a  onClick={() => { handleInfo(record.id) }}>账单明细</a >
                </AuthButton>
            </span>
        }
    }
];


// WEBPACK FOOTER //
// ./src/page/DeviceBill/index.jsx